import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
// import p1 from 'assests/Photos/LifeSkill2023/2024/SeminarGuidance/1.jpg';
// import p2 from 'assests/Photos/LifeSkill2023/2024/SeminarGuidance/2.jpg';
// import p3 from 'assests/Photos/LifeSkill2023/2024/SeminarGuidance/3.jpg';
// import p4 from 'assests/Photos/LifeSkill2023/2024/SeminarGuidance/4.jpg';
// import p5 from 'assests/Photos/LifeSkill2023/Roadsafty/5.jpg';
// import p6 from 'assests/Photos/LifeSkill2023/Roadsafty/6.jpg';
// import p7 from 'assests/Photos/LifeSkill2023/Roadsafty/7.jpg';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar2023 from 'views/LifeSkill2023/Sidebar2023';
import Sidebar2025 from '../LifeSkill2023/Sidebar2025';
import Archive2022 from '../LifeSkill2023/Archive2022';

const Seminar2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2025: '' });
  
  useEffect(() => {
    fetch('/config.json') // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2025}/home/events-activities/life-skill/Seminar/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/life-skill/Seminar/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/life-skill/Seminar/3.webp`;



  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1,
      cols: 1,
    },
    {
      src: p2,
      source:p2,
      rows: 1,
      cols: 1,
    },
    {
      src: p3,
      source: p3,
      rows: 1,
      cols: 1,
    }

  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
       Opportunities of Higher Education in Japan
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
      Classes: 9 & 11  Date: 20 February 2026
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        
        NPS Yeshwanthpur had the privilege of hosting an informative seminar on ‘Opportunities of Higher Education in Japan’on Friday, 20 February 2026 for classes 9 and 11. The session was organised in collaboration with the Indo Japanese Chamber of Commerce and Industry – Karnataka (IJCCIK). 
        <br/>
        The seminar aimed to provide students with valuable insights into higher education prospects in Japan, including information about leading Japanese universities, academic programmes, scholarships, fee structures and career pathways.
        <br/>
        The keynote speaker for the session was Prof. Daisuke Matsushima, Faculty of Transdisciplinary Sciences, Institute of Philosophy in Interdisciplinary Sciences, Nagasaki University, Japan. With an impressive academic and professional background — including education from the University of Tokyo, Harvard University and a Doctorate in Business Administration from Nagasaki University — Prof. Matsushima brought immense expertise and global perspective to the discussion. The seminar proved to be highly enlightening and inspired students to explore global education pathways.
        <br/>
        </Typography>
      </Box>
      {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
       “OPPORTUNITIES DON'T HAPPEN, YOU CREATE THEM”

<br/>
        </Typography> */}

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <Sidebar2025/>
             </Box>
             <Box marginBottom={4}>
               <Archive2022/>
             </Box>

    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default Seminar2025;